import type { GameSavedOptions } from '@merels/room'

export function getEffectiveGameOptionsForStart(
  gameId: string,
  playerCount: number,
  savedOptions: GameSavedOptions | null | Record<string, GameSavedOptions>,
  gameRegistry?: any
): any {
  const metadata = gameRegistry?.getGameMetadata?.(gameId)
  if (!metadata) return {}

  // Handle both single saved options (from RoomState) and map (legacy AppState)
  let saved: GameSavedOptions | undefined
  if (savedOptions && 'global' in savedOptions) {
    saved = savedOptions as GameSavedOptions
  } else if (savedOptions) {
    saved = (savedOptions as Record<string, GameSavedOptions>)[gameId]
  }

  const defaults: Record<string, any> = {}
  
  // Apply defaults from metadata
  if (metadata.options) {
    for (const opt of metadata.options) {
      defaults[opt.id] = opt.defaultValue
      
      // Apply per-player-count default if available
      if (opt.defaultByPlayerCount && opt.defaultByPlayerCount[playerCount] !== undefined) {
        defaults[opt.id] = opt.defaultByPlayerCount[playerCount]
      }
    }
  }

  // Apply saved options
  if (saved) {
    // 1. Apply global options
    if (saved.global) {
      Object.assign(defaults, saved.global)
    }
    // 2. Apply per-player-count options
    if (saved.perPlayerCount && saved.perPlayerCount[playerCount]) {
      Object.assign(defaults, saved.perPlayerCount[playerCount])
    }
  }

  return defaults
}
